/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountDetailsTable.scss';

import { arrayOf, number, shape, string } from 'prop-types';
import React from 'react';

import { Dollar, Percent, Quantity } from 'components/shared/Text/Text';
import { MONEY_MARKET_FORMAT } from 'services/Formats';

const formatComponentMap = {
  dollar: Dollar,
  percent: Percent,
  quantity: Quantity
};

const AccountDetailsTable = ({
  asOfDate,
  header,
  rows,
  mtsAccountData = {},
  isMFESweepAccount = false
}) => (
  <div className="data-table">
    <div>
      <span className="data-table-header">{header}</span>
      <span className="data-table-date">As of {asOfDate}</span>
    </div>
    {rows.map((row, idx) => {
      const { formatWith, label, value, isMoneyMarket } = row;
      const FormatComponent = formatComponentMap[formatWith] || Quantity;
      if (FormatComponent === Dollar && isMoneyMarket) {
        return (
          <div className="data-table-row" key={idx}>
            <div className="row-label">{label}</div>
            <div className="row-value">
              <FormatComponent format={MONEY_MARKET_FORMAT}>
                {value}
              </FormatComponent>
            </div>
          </div>
        );
      }
      return (
        <div className="data-table-row" key={idx}>
          <div className="row-label">{label}</div>
          <div className="row-value">
            <FormatComponent>{value}</FormatComponent>
          </div>
        </div>
      );
    })}

    {isMFESweepAccount ? (
      <p className="data-table-row">
        <div className="row-label">{mtsAccountData?.label}</div>
        <div className="row-value">
          <Dollar>{mtsAccountData?.value}</Dollar>
        </div>
      </p>
    ) : null}
  </div>
);

AccountDetailsTable.propTypes = {
  asOfDate: string.isRequired,
  header: string.isRequired,
  rows: arrayOf(
    shape({
      formatWith: string.isRequired,
      label: string.isRequired,
      value: number.isRequired
    })
  )
};

export default AccountDetailsTable;
